import { CALENDAR_YEARS_LENGTH } from '../constants';

export const getYearOptions = (): number[] => {
    const yearOptions = [];
    for (let i = 0; i <= CALENDAR_YEARS_LENGTH; i++) {
        yearOptions.push(i);
    }
    return yearOptions;
}
